class IWorker extends Worker{

    constructor(instance:any){
        const code = instance.toString();
        const blob = new Blob([`(${code})()`]);
        super(URL.createObjectURL(blob));
    }
}

export default IWorker;